import { RetailChain } from "src/api/types";

export const getChainsMap = (retailChains: RetailChain[]):Record<string,RetailChain> => {
  return retailChains.reduce((acc, retailChain) => {
    acc[retailChain.id] = retailChain;
    return acc;
  }, {});
};
